module.exports = __webpack_public_path__ + "static/media/A6-landscape-v2.63351e8a.png";